// extracted by css-extract-rspack-plugin
export default {"link":"q2A5s"};